
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elections/[stateElection]/results",
      function () {
        return require("private-next-pages/elections/[stateElection]/results/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elections/[stateElection]/results"])
      });
    }
  